<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import mainImagePlaceholder from './main-image.jpg'
    import {api, DataType} from 'src/services/api/reallis'
    import {doShow as showAlert} from 'src/components/#common/alert/store'
    import {generateNftImages, availableImagesCount} from 'src/components/cabinet/#services/nftImages'
    import {Link} from 'svelte-routing'

    const subElements = [
        'Maelstrom',
        'Frosting',
        'SurgingSea',
        'Cloudlet',
        'Vortex',
        'Exhalation',
        'Arboreal',
        'Gravel',
        'Floral',
        'Lambent',
        'Fulgent',
        'Radiant',
        'Steampunk',
        'Militant',
        'Droid',
        'Wildfire',
        'Magma',
        'Blast',
        'Luminous',
        'Beaming',
        'Spiritual',
        'Distorted',
        'Otherworldly',
        'Corruption',
        'Discharge',
        'Energy',
        'Fulminant',
    ];

    let image
    let elementType = 'item'
    let collection = 'meowgon'
    let trait = 'head'
    let element = 'crystal'
    let partType = 0
    let isNft = false
    let collectionForGeneration = 'meowgon'
    let imageInput

    availableImagesCount.send({ data: { collection: collectionForGeneration } })

    async function create() {
        try {
            let response = await api.http.request({
                method: 'post',
                url: process.env.NFT_IMAGES_PATH+'upload',
                dataType: DataType.MultipartFormData,
                data: {
                    collection,
                    isNFT: isNft,
                    type: elementType,
                    traitType: trait,
                    image: imageInput,
                    element,
                    partType
                }
            })
            if (response.data?.location) {
                image = response.data?.location

                showAlert.set({
                    status: 'success',
                    text: 'Image successfully uploaded!'
                })
            } else if (response.data?.err) {
                showAlert.set({
                    status: 'error',
                    text: response.data.err
                })
            }
        } catch (err) {
            showAlert.set({
                status: 'error',
                text: 'An Error Occurred, Please Try Again Later'
            })
        } finally {
            availableImagesCount.reset()
            availableImagesCount.send({data: { collection: collectionForGeneration } })
        }
    }

    async function generate() {
        try {
            await generateNftImages.request({ data: {
                collection: collectionForGeneration
            }})

            showAlert.set({
                status: 'success',
                text: 'You have successfully generated images for NFT'
            })
        } catch (err) {
            showAlert.set({
                status: 'error',
                text: 'An Error Occurred, Please Try Again Later'
            })
        } finally {
            availableImagesCount.reset()
            availableImagesCount.send({data: { collection: collectionForGeneration } })
        }
    }
</script>

<svelte:head>
    <title>NFT creator</title>
</svelte:head>

<MainLayout title="NFT creator">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <div class="form-group mb-3">
                    <Link to="nft/items" class="btn btn-primary">All items</Link>
                    <Link to="nft/images" class="btn btn-primary">NFT images</Link>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group mb-2">
                            <div class="subtitle">Upload images</div>
                        </div>
                        <div class="form-group mb-3">
                            <label>Select type</label>
                            <select class="form-select" bind:value={elementType}>
                                <option value="item">Item</option>
                                <option value="artifact">Artifact</option>
                            </select>
                        </div>
                        <div class="form-group mb-3">
                            <label>Select collection</label>
                            <select class="form-select" bind:value={collection}>
                                <option value="meowgon">Meowgon</option>
                                <option value="kitsune" disabled>Kitsune</option>
                            </select>
                        </div>
                        {#if elementType === 'item'}
                            <div class="form-group mb-3">
                                <label>Select trait</label>
                                <select class="form-select" bind:value={trait}>
                                    <option value="head">Head</option>
                                    <option value="body">Body</option>
                                    <option value="tail">Tail</option>
                                </select>
                            </div>
                            <div class="form-group mb-3">
                                <label>Select element</label>
                                <select class="form-select" bind:value={element}>
                                    <option value="water">Water</option>
                                    <option value="wind">Wind</option>
                                    <option value="earth">Earth</option>
                                    <option value="crystal">Crystal</option>
                                    <option value="iron">Iron</option>
                                    <option value="fire">Fire</option>
                                    <option value="light">Light</option>
                                    <option value="dark">Dark</option>
                                    <option value="electrical">Electrical</option>
                                </select>
                            </div>
                            <div class="form-group mb-3">
                                <label>Select sub element</label>
                                <select class="form-select" bind:value={partType}>
                                    {#each subElements as subElement, idx}
                                        <option value={idx}>{subElement}</option>
                                    {/each}
                                </select>
                            </div>
                        {/if}
                        {#if elementType === 'artifact'}
                            <div class="form-group mb-3">
                                <label>Name</label>
                                <input type="text" class="form-control" placeholder="Enter name">
                            </div>
                            <div class="form-group mb-3">
                                <label>Is NFT?</label>
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input class="form-check-input" type="radio" name="isNft" bind:group={isNft} value={true}>Yes
                                    </label>
                                </div>
                                <div class="form-check">
                                    <label class="form-check-label">
                                        <input class="form-check-input" type="radio" name="isNft" bind:group={isNft} value={false}>No
                                    </label>
                                </div>
                            </div>
                        {/if}
                        <div class="form-group mb-3">
                            <label>Image</label>
                            <div>
                                <label>
                                    <input type="file" class="form-control" accept=".png" on:change={(e) => imageInput = e.target.files[0]}>
                                    {#if image}
                                        <img class="main-image-thumb" src="{process.env.NFT_IMAGES_PATH}{image}" alt=""/>
                                    {:else}
                                        <img class="main-image-thumb" src="{mainImagePlaceholder}" alt=""/>
                                    {/if}
                                </label>
                            </div>
                        </div>
                        <button class="btn btn-success" on:click={() => create()}>Create</button>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group mb-2">
                            <div class="subtitle">Generate images</div>
                        </div>
                        <div class="form-group mb-3">
                            <label>Select collection</label>
                            <select class="form-select" bind:value={collectionForGeneration}>
                                <option value="meowgon">Meowgon</option>
                                <option value="kitsune" disabled>Kitsune</option>
                            </select>
                        </div>
                        <div class="form-group mb-3">
                            {#if !$availableImagesCount.hasValue && $availableImagesCount.loading}
                                <button class="btn btn-success" disabled>Loading...</button>
                            {:else if !$availableImagesCount.hasValue || $availableImagesCount.value <= 0}
                                <button class="btn btn-success" disabled>Generate images</button>
                            {:else if $availableImagesCount.hasValue && $availableImagesCount.value > 0}
                                <button class="btn btn-success mr-2" on:click={() => generate()}>Generate images</button>
                                <span>Available: <strong>{$availableImagesCount.value}</strong></span>
                            {/if}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .subtitle {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 10px;
        border-bottom: 1px solid #ced4da;
        padding-bottom: 10px;
    }

    .main-image-thumb {
        border: 1px solid #ced4da;
        height: 100px;
        margin: 15px 0 0;
        padding: 5px;
        border-radius: 0.25rem;
        cursor: pointer;
    }

    .mr-2 {
        margin-right: 12px;
    }
</style>
